<template>
    <div v-if="isLoading" class="progress-bar">
        <div class="progress"></div>
    </div>
</template>

<script>
import {eventBus} from "../main";

export default {
    name: 'LoadingIndicator',
    data() {
        return {
            isLoading: false,
        };
    },
    created() {
        this.isLoading = true;
        eventBus.$on('loading', (isLoading) => {
            this.isLoading = isLoading;
        });
    },
    beforeDestroy() {
        eventBus.$off('loading');
    },
};
</script>

<style scoped>
.progress-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px; /* Adjust the height of the progress bar */
    z-index: 9999;
}

.progress {
    height: 100%;
    width: 100%;
    background-color: #14aab9; /* Adjust the color of the progress bar */
    animation: progress 1s infinite;
}

@keyframes progress {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingIndicator.vue